import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

import {
	copy,
	selectTransferPresentation,
	selectViewerAdmissionPresentation
} from "@aasaan-share/ui-contract";

var root = $.from_html(`<div role="status"> </div>`);

export default function StatusBand($$anchor, $$props) {
	$.push($$props, true);

	let admissionPresentation = $.derived(() => selectViewerAdmissionPresentation($$props.admission));

	let transferPresentation = $.derived(() => $$props.transferState
		? selectTransferPresentation($$props.transferState)
		: undefined);

	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var div = root();
			var text = $.child(div, true);

			$.reset(div);

			$.template_effect(() => {
				$.set_attribute(div, 'aria-live', $.get(admissionPresentation).announce ? "polite" : undefined);
				$.set_class(div, 1, `status-band status-${$.get(admissionPresentation).tone}`);
				$.set_text(text, copy[$.get(admissionPresentation).copyKey]);
			});

			$.append($$anchor, div);
		};

		var consequent_1 = ($$anchor) => {
			var div_1 = root();
			var text_1 = $.child(div_1, true);

			$.reset(div_1);

			$.template_effect(() => {
				$.set_attribute(div_1, 'aria-live', $.get(transferPresentation).announce ? "polite" : undefined);
				$.set_class(div_1, 1, `status-band status-${$.get(transferPresentation).tone}`);
				$.set_text(text_1, copy[$.get(transferPresentation).copyKey]);
			});

			$.append($$anchor, div_1);
		};

		$.if(node, ($$render) => {
			if ($$props.admission !== "connected" && $.get(admissionPresentation).copyKey) $$render(consequent); else if ($.get(transferPresentation)?.copyKey) $$render(consequent_1, 1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}